import { List } from 'antd';
import React from 'react';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';

import PartnerMask from 'components/_shared/PartnerMask';
import { Redux } from 'helpers/types/_common';

import S from './helpers/styles.module.sass';
import ReplaceHourActivityListItemProps from './helpers/types';

const cx = classNames.bind(S);

const ReplaceHourActivityListItem: React.FC<ReplaceHourActivityListItemProps> = ({ activityObject, handleSave }) => {
  const { tableSettings } = useSelector((state: Redux) => state.timeSheet);

  const onClickHandler = () => {
    if (tableSettings.isMonthClosed) {
      return;
    }

    handleSave(activityObject.activity.activityId);
  };

  return (
    <List.Item
      key={activityObject.userPinnedActivityId}
      className={cx(S.activityListItem, S.withPadding, {
        [S.monthClosedActivityItem]: tableSettings.isMonthClosed,
      })}
      title={`${activityObject.activity.partner.name}: ${activityObject.activity.name}`}
      onClick={onClickHandler}
    >
      <List.Item.Meta
        className={S.activityListItemMeta}
        description={(
          <div className={S.activityListItemDescription}>
            <PartnerMask
              wrapperColor={activityObject.activity.partner.color}
              mask={activityObject.activity.partner.mask}
              wrapperClassName={S.activityIconWrapper}
              partnerId={activityObject.activity.partner.partnerId}
              iconColor={activityObject.activity.color}
              isVacation={activityObject.activity.partner.isVacation}
            />
            <p className={S.descriptionTextWrapper}>
              <span className={S.descriptionText}>{`${activityObject.activity.partner.name}: ${activityObject.activity.name}`}</span>
            </p>
          </div>
        )}
      />
    </List.Item>
  );
};

export default ReplaceHourActivityListItem;
